import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import CollectionsBootstrap from 'modules/posts/lib/PostsCollectionsBootstrap'

const PostsRootPage = () => {
  return (
    <Box flexGrow>
      <CollectionsBootstrap>
        <Outlet />
      </CollectionsBootstrap>
    </Box>
  )
}

export default PostsRootPage
